import { render, staticRenderFns } from "./ContactFormInputs.vue?vue&type=template&id=5b8a847e&scoped=true&"
import script from "./ContactFormInputs.vue?vue&type=script&lang=js&"
export * from "./ContactFormInputs.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormInputs.vue?vue&type=style&index=0&id=5b8a847e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a847e",
  null
  
)

export default component.exports